import React from "react";
import { UserSearchInput } from "./UserSearchInput";

interface SecretSantaInputProps {
  isSecretSantaTrack: boolean;
  onIsSecretSantaTrackChange: (value: boolean) => void;
  secretSantaRecipient: string;
  onSecretSantaRecipientChange: (value: string) => void;
  secretSantaPromptText: string;
  onSecretSantaPromptTextChange: (value: string) => void;
}

export function SecretSantaInput({
  isSecretSantaTrack,
  onIsSecretSantaTrackChange,
  secretSantaRecipient,
  onSecretSantaRecipientChange,
  secretSantaPromptText,
  onSecretSantaPromptTextChange,
}: SecretSantaInputProps): JSX.Element {
  return (
    <>
      <div className="flex items-center gap-3">
        <span className="text-6xl">🎅</span>
        <input
          type="checkbox"
          id="is_secret_santa_track"
          checked={isSecretSantaTrack}
          onChange={(e) => onIsSecretSantaTrackChange(e.currentTarget.checked)}
          className="h-7 w-7 rounded border-slate-300 text-chips-gold focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10"
        />
        <label
          htmlFor="is_secret_santa_track"
          className="text-2xl font-medium text-slate-700 dark:text-slate-200"
        >
          <div>This is a Secret Santa gift</div>
          <div className="text-sm text-slate-500 dark:text-slate-400">
            (You will be able to change everything here later)
          </div>
        </label>
      </div>

      {isSecretSantaTrack && (
        <div className="mt-4 space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
              Who is this gift for?
            </label>
            <UserSearchInput
              defaultValue={secretSantaRecipient}
              placeholder="Enter username..."
              onValueChange={onSecretSantaRecipientChange}
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-300">
              What was their Secret Santa request?
            </label>
            <textarea
              value={secretSantaPromptText}
              onChange={(e) => onSecretSantaPromptTextChange(e.target.value)}
              rows={3}
              placeholder="Paste their request here..."
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-slate-900 placeholder-slate-400 focus:border-chips-gold focus:outline-none focus:ring-2 focus:ring-chips-gold/20 dark:border-white/10 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500"
            />
          </div>
        </div>
      )}
    </>
  );
}
